import styled from 'styled-components';

export const LoaderContainer = styled.div`
  display: ${({ loading }) => (loading ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #ffffffb2;
  z-index: 9999;
`;

export const DoughnutLoader = styled.div`
  position: relative;
  width: 100px;
  height: 120px;
`;

export const ProgressRing = styled.svg`
  width: 100%;
  height: 100%;
`;

export const ProgressRingCircle = styled.circle`
  fill: none;
  stroke: #eee;
  stroke-width: 8;
`;

export const ProgressBar = styled.circle`
  fill: none;
  stroke: #3730a3;
  stroke-width: 8;
  stroke-linecap: round;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
`;

export const LoadingText = styled.div`
  position: absolute;
  top: 110px;
  font-size: 18px;
  color: #3730a3;
  font-weight: 500;
`;
